import config from '@/config';

export const screenLayoutLink = (screenId) => `${config.apiUrl}userapi/screens/${screenId}/layout`;
